import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahClientInvoices } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

export const clientInvoicesApi = createApi({
  reducerPath: 'clientInvoicesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahClientInvoices }),
  tagTypes: ['client-invoices'],
  endpoints: (builder) => ({
    getClientInvoices: builder.query<any[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'client-invoices', id: 'LIST' }],
      transformResponse: (payload) => unwrap<any[]>(payload),
    }),
    getClientInvoice: builder.query<any, Request & { id: string }>({
      query: ({ id, ...rest }) => ({ url: `/${id}`, method: 'GET', params: rest }),
      providesTags: (_result, _error, { id }) => [{ type: 'client-invoices', id }],
      transformResponse: (payload) => unwrap<any>(payload),
    }),
    createClientInvoice: builder.mutation<any, Request>({
      query: (body) => ({ url: '', method: 'POST', body }),
      invalidatesTags: [{ type: 'client-invoices', id: 'LIST' }],
      transformResponse: (payload) => unwrap<any>(payload),
    }),
  }),
});

export const { useGetClientInvoicesQuery, useGetClientInvoiceQuery, useCreateClientInvoiceMutation } =
  clientInvoicesApi;
